/* eslint-disable react/require-default-props */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import 'dayjs/locale/lt';

import IconConfig from '@assets/icons/config.svg?react';
import {
 Dialog,
 DialogContent,
 DialogTitle,
 IconButton,
 Typography,
 useMediaQuery,
 useTheme,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
 Dispatch,
 memo,
 MutableRefObject,
 SetStateAction,
 useMemo,
 useRef,
} from 'react';
import { useTranslation } from 'react-i18next';

import { useFieldsConfig } from '../../../contexts/useFieldsConfigDialog';
import { usePage } from '../../../contexts/usePageContext';
import themeOptions from '../../../utils/theme';
import CloseButton from '../CloseButton';
import { CustomGridApi, TableModalState } from '../XTable/types';
import EditTabsWrapper from './EditTabsWrapper';

const defaultWidth = { xs: '100%', md: '410px' };

const EditModal = memo(
 ({
  setCreateModalOpen,
  isOpen,
  modalState,
  setModalState,
  apiRef,
 }: {
  setCreateModalOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  modalState?: TableModalState;
  setModalState: Dispatch<SetStateAction<TableModalState>>;
  apiRef: MutableRefObject<CustomGridApi>;
 }) => {
  const { pageName } = usePage();
  const { t } = useTranslation();
  const th = useTheme();
  const { openDialog: openFieldsConfigDialog } = useFieldsConfig();
  const contentRef = useRef<HTMLDivElement>(null);

  const hasFieldsConfig = useMemo(
   () => ['results'].includes(pageName),
   [pageName],
  );

  const isLargerThanMd = useMediaQuery(themeOptions().breakpoints.up('md'));

  const handleClose = () => {
   setModalState({ id: -1, action: 'create' });

   setCreateModalOpen(false);
  };

  return (
   <Dialog
    open={isOpen}
    onClose={handleClose}
    fullScreen={!isLargerThanMd}
    maxWidth="lg"
    sx={{
     '& .MuiDialog-container': {
      '& .MuiPaper-root': {
       maxWidth: defaultWidth,
      },
     },
     '& .MuiDialog-paper': {
      overflow: 'hidden',
     },
    }}
   >
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="lt">
     <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <Typography sx={{ fontSize: 18, fontWeight: 500 }}>
       {modalState?.action === 'create' && t('global.create')}
       {modalState?.action === 'update' && t('global.edit')}
       {modalState?.action === 'duplicate' && t('global.duplicate')}
      </Typography>
      {/* FIX THIS !!!!!!!!!!!!!!! */}
      {hasFieldsConfig && (
       <IconButton
        title={t('fieldsModal.fieldSettings')}
        aria-label={t('fieldsModal.fieldSettings')}
        onClick={() => openFieldsConfigDialog({ type: 'edit' })}
       >
        <IconConfig style={{ color: th.palette.kemek.darkestGray }} />
       </IconButton>
      )}
     </DialogTitle>
     <CloseButton closeDialog={handleClose} />
     {/* {JSON.stringify(errors)} */}
     <DialogContent
      ref={contentRef}
      sx={{
       paddingTop: 0,
       padding: 0,
       overflow: 'hidden',
       display: 'flex',
       width: defaultWidth,
       height: '100%',
      }}
     >
      <EditTabsWrapper
       handleClose={handleClose}
       modalState={modalState}
       setModalState={setModalState}
       setCreateModalOpen={setCreateModalOpen}
       isOpen={isOpen}
       apiRef={apiRef}
       contentRef={contentRef}
      />
     </DialogContent>
    </LocalizationProvider>
   </Dialog>
  );
 },
);
EditModal.displayName = 'EditModal';
export default EditModal;
